export enum AssetDepreciationPeriodType {
Months,
Days,
}
